import styled from '@emotion/styled'

export const CenterRow = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
